// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isCanvasTemplatesResult = objectOf({
  id: string,
  template_name: string,
  tags: arrayOf(string),
  description: string,
  created_by: string,
  team: string,
});
